var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.src)?_c('img',{attrs:{"src":_vm.src}}):_c('div',{staticClass:"pasimage"},[_c('span')])])
}
var staticRenderFns = []

export { render, staticRenderFns }